import { render, staticRenderFns } from "./fresh.vue?vue&type=template&id=aed80de4&scoped=true&"
import script from "./fresh.vue?vue&type=script&lang=js&"
export * from "./fresh.vue?vue&type=script&lang=js&"
import style0 from "./fresh.vue?vue&type=style&index=0&id=aed80de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed80de4",
  null
  
)

export default component.exports